import './TicketOverlay.less';

import React, { useState } from 'react';

import { Fullscreen } from '@/ui/dialogs/Dialog';
import ArrowIcon from 'nike-ui/src/icons/svg/arrow-icon-sv.svg';
import CloseIcon from '@/icons/DeleteIcon';
import PopupNg from '@/ui/PopupNg';
import i18n from '@i18n';
import { SuspendedTicketDetailSubscriber } from '@/mytickets/detail/views/SuspendedTicketDetail';
import { cashinClosingModeAnyActive$ } from 'nike-ui/src/components/ticketus/subs';
import { useReframe, dispatch } from 'nike-re-framejs';
import { clearCashinClosingMode } from 'nike-ui/src/components/ticketus/handlers';

const close = () => {
    dispatch(clearCashinClosingMode);
    PopupNg.dispatcher.close('ticketDetail');
};

const findPrevAndNextHash = (hashes, hash) => {
    if (!Array.isArray(hashes)) {
        return [null, null];
    }
    // todo: optimize?
    const index = hashes.findIndex(_ => _ === hash);
    if (index === -1) {
        return [null, null];
    }
    const prev = index > 0 ? hashes[index - 1] : null;
    const next = index < hashes.length - 1 ? hashes[index + 1] : null;
    return [prev, next];
};

const TicketOverlay = ({ hash, hashes = [] }) => {
    const { subscribe } = useReframe();
    const [currentHash, setCurrentHash] = useState(hash);
    const [prevHash, nextHash] = findPrevAndNextHash(hashes, currentHash);
    const cashinClosingModeActive = subscribe(cashinClosingModeAnyActive$);

    return (
        <Fullscreen className="ticket-overlay" onClose={close}>
            <div className="arrows">
                <div className="ticket-arrows">
                    {prevHash && !cashinClosingModeActive ? (
                        <TicketArrows className="left-arrow" prevHash={prevHash} setCurrentHash={setCurrentHash} />
                    ) : (
                        <div className="empty-arrow" />
                    )}
                </div>
                <TicketOverlayContent currentHash={currentHash} />
                <div className="ticket-arrows">
                    {nextHash && !cashinClosingModeActive ? (
                        <TicketArrows className="right-arrow" nextHash={nextHash} setCurrentHash={setCurrentHash} />
                    ) : (
                        <div className="empty-arrow" />
                    )}
                </div>
            </div>
        </Fullscreen>
    );
};

const TicketOverlayContent = ({ currentHash }) => {
    return (
        <div className="ticket-overlay-wrapper">
            <div className="ticket-overlay-header">
                <div className="header-title">
                    <h2>{i18n('ticket.detail.title')}</h2>
                </div>
                <div className="close-icon" onClick={close}>
                    <CloseIcon fill="#ffffff" width="16" />
                </div>
            </div>
            <SuspendedTicketDetailSubscriber isActive hash={currentHash} headerInDialog={false} />
        </div>
    );
};

const TicketArrows = ({ setCurrentHash, prevHash, nextHash, className }) => {
    const onClick = () => {
        setCurrentHash(className === 'left-arrow' ? prevHash : nextHash);
    };

    return (
        <div className={className === 'left-arrow' ? 'left-arrow' : 'right-arrow'} onClick={onClick}>
            <ArrowIcon fill="#ffffff" width="15" height="26" />
        </div>
    );
};

export default TicketOverlay;
